export const DOCUMENT_TYPES = {
  CPF: 'CPF',
  CNPJ: 'CNPJ',
} as const;

export type DocumentType = (typeof DOCUMENT_TYPES)[keyof typeof DOCUMENT_TYPES];

export const DOCUMENT_TYPES_LABELS: Record<DocumentType, string> = {
  [DOCUMENT_TYPES.CPF]: 'CPF',
  [DOCUMENT_TYPES.CNPJ]: 'CNPJ',
};

export interface DocumentTypeOption {
  value: DocumentType;
  label: string;
}

export const DOCUMENT_TYPES_OPTIONS: DocumentTypeOption[] = Object.values(
  DOCUMENT_TYPES,
).map(value => ({
  value,
  label: DOCUMENT_TYPES_LABELS[value],
}));

export function getDocumentTypeLabel(value?: DocumentType | null): string {
  if (!value) {
    return '';
  }

  return DOCUMENT_TYPES_LABELS[value] ?? value;
}
